import React from "react";

const RichToastContent = ({ title, description, showDivider = false }) => (
  <div
    className={`toast-rich-content${
      showDivider ? " toast-rich-content--with-divider" : ""
    }`}
  >
    <div className="toast-rich-content__title">{title}</div>
    {showDivider ? <div className="toast-rich-content__divider" /> : null}
    <div className="toast-rich-content__description">{description}</div>
  </div>
);

export default RichToastContent;
